import React from 'react';
import { XIcon } from 'lucide-react';
import { problems, problemsTitle } from '../data/content';
export function Problem() {
  return <section className="w-full bg-night-800 py-16 md:py-24" data-id="element-141" data-mp="2peyzijo6rygs">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-142" data-mp="2bg94d9kxg8v2">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[2rem] font-bold leading-[1.15] tracking-tight text-ink md:text-[2.75rem]" data-id="element-143" data-mp="2bi27iewc0ayb">
          {problemsTitle}
        </h2>

        <ul className="mx-auto mt-14 grid max-w-narrow gap-4 md:grid-cols-2" data-id="element-144" data-mp="21ntku7tzfc82">
          {problems.map(problem => <li key={problem.title} className="flex h-full flex-col rounded-2xl bg-night-700 p-6 text-left ring-1 ring-white/5 md:p-7" data-id="element-145" data-mp="1sp86kovjmjd3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-alert-500/10 text-alert-300" data-id="element-146" data-mp="1woqqpifjiqev">
                <XIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-147" data-mp="1nq59prppvjg7" />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold leading-snug tracking-tight text-ink" data-id="element-148" data-mp="t9x2x7lgsa3d">
                {problem.title}
              </h3>
              <p className="mt-3 text-muted" data-id="element-149" data-mp="oac3kw2dtzq4">{problem.detail}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}